









import { Component, Vue } from 'vue-property-decorator'
import { ReferralCount } from '@/api/types'
import { PieChart } from 'vue-chart-3'
import { Chart, ChartData, ChartOptions, PieController, ArcElement, ChartEvent, LegendItem, LegendElement, ActiveElement } from 'chart.js'
import ChartDataLabels from 'chartjs-plugin-datalabels'
import { namespace } from 'vuex-class'
const referrals = namespace('referrals')
Chart.register(PieController, ArcElement)

@Component({
    components: {
        PieChart,
    },
})
export default class LegacyChartReferralAge extends Vue {
    @referrals.State readonly referralCounts!: ReferralCount
    @referrals.State readonly ageFilter!: string
    @referrals.Action applyAgeFilter: ({ ageFilter: ReferralAge }) => Promise<void>

    onChartRender(chart: Chart) {
        // @ts-ignore
        const legendItems = chart.legend.legendItems
        legendItems.forEach((item, index) => {
            const key = Object.keys(this.chartValues)[index]
            item.hidden = this.ageFilter && this.ageFilter !== key
        })
    }

    get chartData(): ChartData {
        if (!this.chartValues) {
            return null
        }

        return {
            labels: this.chartLabels,
            datasets: [
                {
                    data: Object.values(this.chartValues),
                    backgroundColor: this.chartColors,
                    datalabels: {
                        color: 'rgba(255, 255, 255, .75)',
                    },
                },
            ],
        }
    }

    get chartOptions(): ChartOptions<'pie'> {
        return {
            responsive: true,
            maintainAspectRatio: true,
            aspectRatio: 4,
            animation: {
                easing: 'easeOutExpo',
            },
            plugins: {
                legend: {
                    position: 'right',
                    onClick: (e: ChartEvent, legendItem: LegendItem, legend: LegendElement) => {
                        // @ts-ignore type defines datasetIndex but it is index at runtime
                        this.onClick(legendItem.index)
                    },
                },
                tooltip: {
                    enabled: false,
                },
            },
            onClick: (event: ChartEvent, elements: ActiveElement[], chart: Chart) => {
                if (elements.length === 0) {
                    return
                }

                this.onClick(elements[0].index)
            },
        }
    }

    get chartPlugins(): object[] {
        return [
            ChartDataLabels,
        ]
    }

    get chartValues(): {[key: string]: number} {
        if (!this.referralCounts) {
            return {}
        }

        const chartValues = {
            age90: this.referralCounts.age90,
            age180: this.referralCounts.age180,
            age365: this.referralCounts.age365,
        }

        return chartValues
    }

    get chartLabels(): string[] {
        const labels = {
            age90: '90 dagen',
            age180: '180 dagen',
            age365: '365 dagen',
        }

        const chartLabels = []
        Object.keys(this.chartValues).forEach(key => {
            const label = labels[key]
            chartLabels.push(`${label} (${this.chartValues[key]})`)
        })

        return chartLabels
    }

    get chartColors(): string[] {
        const colors = {
            age90: 'rgb(222, 64, 119)',
            age180: 'rgb(64,135,222)',
            age365: 'rgb(0, 163, 137)',
        }

        const chartColors = []
        Object.keys(this.chartValues).forEach(key => {
            const color = colors[key]
            chartColors.push(color)
        })

        return chartColors
    }

    onClick(selectedIndex: number): void {
        const selectedKey = Object.keys(this.chartValues)[selectedIndex]

        if (this.ageFilter !== selectedKey) {
            this.applyAgeFilter({ ageFilter: selectedKey })
        } else {
            this.applyAgeFilter({ ageFilter: null })
        }
    }
}
